import { useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import CustomSpinner from '~/commonComponents/CustomSpinner';
import { Box, Center, Text } from '~/commonComponents';
import { useScrollRestore } from '~/hooks/useScrollRestore';
import { CardActionsHeader } from '../CardActionsHeader';
import { ProfessionalCard } from '../ProfessionalCard';
import { EmptyRecommendedPros } from './EmptyRecommendedPros';
import { ProfessionalCardActions } from './ProfessionalCardActions';
import { ProfessionalCardDetails } from './ProfessionalCardDetails';
import { EmptyFilteredList } from '../EmptyFilteredList';
import { useRecommendedProsList } from './hooks/useRecommendedProsList';

export const RecommendedProsList = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useScrollRestore('RecommendedProsList', scrollRef);

  const { recommendedProfessionals, isLoading, isEmpty, isFiltered, filter } =
    useRecommendedProsList();

  if (isLoading) {
    return <CustomSpinner isLoading size={24} />;
  }

  if (isEmpty) {
    return (
      <>
        {isFiltered && <EmptyFilteredList />}
        {!isFiltered && <EmptyRecommendedPros />}
      </>
    );
  }

  return (
    <Box width="100%">
      <Center position="relative" textAlign="center">
        <Text fontStyle="italic" color="neutral_500">
          The following professionals have shown reliability at other nearby offices. Send an invite
          and fill your shift faster!
        </Text>
      </Center>

      <div
        ref={scrollRef}
        style={{
          maxWidth: '827px',
          marginTop: 32,
          display: 'flex',
          justifyContent: 'center',
          marginLeft: 'auto',
          marginRight: 'auto',
          height: 600,
          overflowY: 'auto',
        }}
      >
        <motion.div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 24,
            padding: '0 50px',
          }}
          layout
        >
          <AnimatePresence>
            <CardActionsHeader actions={['Invite', 'Block']} />
            {recommendedProfessionals?.map((item) => (
              <ProfessionalCard
                key={item?.id}
                user={{
                  id: item?.id,
                  fullname: item?.fullname,
                  profileImage: item?.profile_image,
                  profession:
                    item?.professions?.find((prof) => prof === filter) || item?.professions?.[0],
                  rating: item.rating,
                  isAvailable: true,
                }}
                Details={ProfessionalCardDetails}
                Actions={ProfessionalCardActions}
                showRemoveIcon={false}
              />
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </Box>
  );
};
